import axios from 'axios';

// Dynamically detect API base URL
const getApiBaseUrl = () => {
  // If environment variable is set, use it (for local development)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // In production, use the current domain (works for both millmind.ai and jmc.aiguru.pro)
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const host = window.location.host;
    return `${protocol}//${host}`;
  }

  // Fallback for local development
  return 'http://localhost:8001';
};

const API_BASE_URL = getApiBaseUrl();


const getToken = () => localStorage.getItem('jmc_token');

const request = async ({ method = 'GET', url, data = null,params=null, headers = {} }) => {
  try {
    const token = getToken();
    // Build headers safely: do not force a Content-Type for FormData
    const hdrs = {
      Authorization: token ? `Bearer ${token}` : '',
      ...headers,
    };
    if (!(data instanceof FormData) && !hdrs['Content-Type']) {
      hdrs['Content-Type'] = 'application/json';
    }

    const config = {
      method,
      url: `${API_BASE_URL}${url}`,
      headers: hdrs,
      data,
      params
    };

    const response = await axios(config);
    return response.data; 
  } catch (error) {
    console.error('API Error:', error.message || error.response || error);

    // Extract user-friendly error message
    let userMessage = 'Something went wrong. Please try again.';

    if (error.response) {
      // Server responded with error
      if (error.response.data && error.response.data.detail) {
        userMessage = error.response.data.detail;
      } else if (error.response.status === 401) {
        userMessage = 'Please log in to continue';
      } else if (error.response.status === 403) {
        userMessage = 'You don\'t have permission to perform this action';
      } else if (error.response.status === 404) {
        userMessage = 'The requested resource was not found';
      } else if (error.response.status >= 500) {
        userMessage = 'Server error. Please try again later or contact support';
      }
    } else if (error.request) {
      // Request made but no response
      userMessage = 'Unable to connect to server. Please check your internet connection';
    }

    // Add user-friendly message to error while preserving original properties
    error.message = userMessage;
    throw error;
  }
};

// Convenience methods  
export const get = (url, params = {},headers = {}) => request({method: 'GET', url, params, headers });
export const post = (url, data, headers = {}) => request({ method: 'POST', url, data, headers });
export const put = (url, data, headers = {}) => request({ method: 'PUT', url, data, headers });
export const apiDelete = (url, headers = {}) => request({ method: 'DELETE', url, headers });
